"use strict";

var PropTypes = require("prop-types");

// Note: this is different from the other quantity component because it needs to support blur functionality
// see JavaScript/productComponents/Quantity.jsx

var LoggerInstance = require("js-logger").get("CartItemQuantity");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

class CartItemQuantity extends React.Component {
	constructor(props) {
		super(props);

		var state = this.getStateFromStore(props);
		state.focused = false;

		if (props.isDesignMode) {
			state.quantity = 1;
		}

		this.state = state;

		this._onChange = this._onChange.bind(this);
	}

	handleBlur(event) {
		// must be whole number, > 0
		var quantity = event.currentTarget.value;
		var isValidQuantity = quantity.match(/^[1-9]\d*$/) !== null;

		if (!isValidQuantity) {
			CheckoutActions.setProductQuantity(this.props.cartItemId, 1);
		} else {
			CheckoutActions.setProductQuantity(this.props.cartItemId, quantity);
		}

		this.setState({ focused: false }, () => {
			if (!this.props.isDesignMode) {
				CheckoutActions.updateProduct(this.props.cartItemId);
			}
		});
	}

	handleFocus() {
		this.setState({ focused: true });
	}

	handleAmountChange(event) {
		// must be whole number, > 0
		if (event.currentTarget.value === "0") {
			CheckoutActions.setProductQuantity(this.props.cartItemId, 1);
		} else if (event.currentTarget.value.match(/^\d*$/)) {
			CheckoutActions.setProductQuantity(this.props.cartItemId, event.currentTarget.value);
		}
	}

	getStateFromStore(props) {
		return {
			quantity: CheckoutStore.getProductQuantity((props || this.props).cartItemId)
		};
	}

	_onChange() {
		this.setState(this.getStateFromStore());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setProductQuantity(this.props.cartItemId, null);
		}
	}

	render() {
		var quantity = this.state.quantity;

		return (
			<span
				data-react-component-name="CartItemQuantity"
				data-react-component-category="ProductCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="text"
					value={quantity}
					onBlur={this.handleBlur.bind(this)}
					onChange={this.handleAmountChange.bind(this)}
					onFocus={this.handleFocus.bind(this)}
					className={this.props.className}
					data-override-classes={this.props.className}
					inputMode="numeric"
				/>
			</span>
		);
	}
}

CartItemQuantity.propTypes = {
	className: PropTypes.string,
	isDesignMode: PropTypes.bool,
	cartItemId: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = CartItemQuantity;
